import React, { useEffect, useState } from "react";
import { AIRTABLE_URL_TECHNICIAN, AIRTABLE_HEADERS } from "../constants";

export default function ResolveTechnicianIssue() {
  const [issues, setIssues] = useState([]);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");

  useEffect(() => {
    fetchPendingIssues();
  }, []);

  const fetchPendingIssues = async () => {
    setLoading(true);
    try {
    const res = await fetch(`${AIRTABLE_URL_TECHNICIAN}?filterByFormula=complaintStatus%3D%22Pending%22`, {
  headers: AIRTABLE_HEADERS, // ✅ centralized headers
});
      const data = await res.json();
      setIssues(data.records);
    } catch (err) {
      console.error("Fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleResolve = async (id, adminResponse) => {
    if (!adminResponse.trim()) {
      alert("Please enter response before resolving.");
      return;
    }

    try {
   const res = await fetch(`${AIRTABLE_URL_TECHNICIAN}/${id}`, {
  method: "PATCH",
  headers: AIRTABLE_HEADERS, // ✅ use centralized headers from constants.js
  body: JSON.stringify({
    fields: {
      complaintStatus: "Resolved",
      adminResponse: adminResponse,
    },
  }),
});

      const data = await res.json();
      console.log("✔️ Updated:", data);
      setStatus("✅ Issue marked as resolved.");
      fetchPendingIssues(); // Refresh list
    } catch (err) {
      console.error("Resolve error:", err);
      setStatus("❌ Failed to resolve issue.");
    }
  };

  return (
    <div style={{ padding: 30 }}>
      <h2>🛠️ Pending Technician Issues</h2>
      {loading ? <p>Loading...</p> : null}
      {status && <p>{status}</p>}

      {issues.length === 0 && !loading && <p>🎉 No pending issues.</p>}

      {issues.map((issue) => {
        const fields = issue.fields;
        return (
          <div
            key={issue.id}
            style={{
              border: "1px solid #ccc",
              borderRadius: 8,
              padding: 15,
              marginBottom: 20,
              backgroundColor: "#f9f9f9"
            }}
          >
            <p><strong>🆔 Issue ID:</strong> {fields.issueId}</p>
            <p><strong>👨‍🔧 Technician:</strong> {fields.technicianName}</p>
            <p><strong>📞 Phone:</strong> {fields.technicianPhone}</p>
            <p><strong>📋 Category:</strong> {fields.issueCategory}</p>
            <p><strong>📝 Description:</strong> {fields.issueDescription}</p>
            <p><strong>🕒 Date:</strong> {fields.issueDateTime}</p>

            <textarea
              placeholder="✍️ Enter admin response"
              onChange={(e) => {
                issue.adminResponseText = e.target.value;
              }}
              style={{ width: "100%", padding: 10, marginBottom: 10 }}
            />

            <button
              onClick={() => handleResolve(issue.id, issue.adminResponseText || "")}
              style={{
                backgroundColor: "#28a745",
                color: "white",
                padding: "10px 20px",
                border: "none",
                borderRadius: 4,
                cursor: "pointer"
              }}
            >
              ✅ Mark as Resolved
            </button>
          </div>
        );
      })}
    </div>
  );
}
